<template>
  <div>
    <div class="materialDetailBox">
      <div class="materialDetailHeader">
        <BreadCrumbs :breadList="breadList"></BreadCrumbs>
        <MiniSearch searchType="PS"></MiniSearch>
      </div>
      <div class="materialDetailContent">
        <div class="contentLeft">
          <!-- <PsDetailImgShow
            :srcList="detailInfo.preview"
            type="su"
          ></PsDetailImgShow> -->
          <img :src="detailInfo.preview" alt="" />
        </div>
        <div class="contentRight">
          <div class="rightTop">
            <PsDetailInfo
              :authorInfo="authorInfo"
              :fid="1196"
              :detailId="detailId"
              @downloadFun="downloadFun"
              @getYunCodeFun="getYunCodeFun"
              :info="detailInfo"
            ></PsDetailInfo>
						<div class="free" @click="freeReceive">
							<img src="../../assets/image/free.gif" alt="">
						</div>
          </div>
        </div>
      </div>
    </div>
    <div class="recommendBox">
      <p class="f22 c_33 f_b">相关PS素材推荐</p>
      <PsList
        class="mt30"
        :photoList="recommendList.data"
        :listStatus="listStatus"
				ref="list"
				@nextPage="nextPage"
      ></PsList>
    </div>
  </div>
</template>

<script>
import MiniSearch from "@/components/MiniSearch";
// import PsDetailImgShow from "@/components/PsDetailImgShow";
import PsDetailInfo from "./components/PsDetailInfo";
import BreadCrumbs from "@/components/BreadCrumbs";
import PsList from "@/components/PsList";
import {
  getAuthorInfo,
  getMaterialCanDown,
  getPSDetail,
  cloudLibrarygetCateNav,
	checkDownTimes
} from "../../Api";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  name: "SuDetail",
  components: {
    MiniSearch,
    // PsDetailImgShow,
    PsDetailInfo,
    PsList,
    BreadCrumbs,
  },
  data() {
    return {
      downloadUrl: "",
      detailId: "",
      detailInfo: {
        preview: [],
      },
      breadList: [],
      authorInfo: {},
      recommend: [],
      authorOther: [],
      payObj: {
        payStatus: "noPay",
        isTopUp: false,
      },
      recommendSuList: [],
			loading: true,
			getListParams: {
				id: this.$route.query.detailId,
				page: 0,
				per_page: 30,
			},
			listStatus: {
				isData: true,
				isNull: false,
			},
			shareId: '',
    };
  },
  created() {
    this.detailId = this.$route.query.detailId;
		if (this.$route.query.shareId) {
			this.shareId = this.$route.query.shareId;
		}
    this.initData();
  },
  methods: {
    initData() {
      Promise.all([
        this.getDetailInfo(),
        this.getAuthor(),
        this.getCateNav(),
      ]).then(() => {});
    },
		// 免费领知币弹窗
		freeReceive() {
			this.$picturePop().show()
		},
    //面包屑
    getCateNav() {
      new Promise((resolve) => {
        cloudLibrarygetCateNav(this.detailId).then((res) => {
          this.breadList = res.data;
          resolve();
        });
      });
    },
		// 加载下一页
		nextPage() {
			this.getListParams.page += 1;
		},
    //获取详情
    getDetailInfo() {
      return new Promise((resolve, reject) => {
				const params = { id: this.detailId, token: getToken() };
				if (this.shareId) {
					params.share_id = this.shareId
				}
        getPSDetail(params)
          .then((res) => {
            const { data } = res;
            this.detailInfo = data;
            document.title = res.data.name + " - PS素材 - 知设网";
            resolve();
          })
          .catch((error) => {
            console.log("错误");
            reject(error);
          });
      });
    },
    // 获取作者信息
    getAuthor() {
      return new Promise((resolve, reject) => {
        //  作者信息
        getAuthorInfo({ id: this.detailId })
          .then((res) => {
            this.authorInfo = res.data;
          })
          .catch((error) => {
            console.log("错误");
            reject(error);
          });
      });
    },
    // 获取提取码
    getYunCodeFun() {
      //判断是否登录
      this.$login({ isRouter: false }).then((res) => {
        const { isLogin } = res;
        if (isLogin) {
          this.getCanDown().then((canDowRes) => {
            if (canDowRes === "appreciate") {
              const info = { ...this.detailInfo };
              if (info.user_is_vip == 1) {
                info.zsStr = (info.zsStr * 0.8).toFixed(1);
              }
              const data = {
                //传递给函数式组件的值（慎用哦）
                userToken: getToken(),
                detailId: this.detailId, // 项目id
                balance: this.balance, // 知币余额
                projectInfo: info, // 项目详情
                authorUid: this.authorInfo.uid, // 作者uid
                title: "下载PS素材",
                titleDec: "PS素材名称",
              };
              this.payObj = this.$payPop({ data: data }); // 支付弹窗
              this.payObj.show();
            }
          });
        }
      });
    },
    //下载su
    downloadFun(shareId) {
      this.$login({ isRouter: false }).then((res) => {
        const { isLogin } = res;
        if (isLogin) {
          this.getCanDown(shareId).then((canDowRes) => {
            if (canDowRes === "appreciate") {
              const info = { ...this.detailInfo };
              if (info.user_is_vip == 1) {
                info.zsStr = (info.zsStr * 0.8).toFixed(1);
              }
              const data = {
                //传递给函数式组件的值（慎用哦）
                userToken: getToken(),
                detailId: this.detailId, // 项目id
                balance: this.balance, // 知币余额
                projectInfo: info, // 项目详情
                authorUid: this.authorInfo.uid, // 作者uid
                title: "下载PS素材",
                titleDec: "PS素材名称",
              };
              this.payObj = this.$payPop({ data: data }); // 支付弹窗
              this.payObj.show();
            } else if (canDowRes === "down") {
							checkDownTimes({token: getToken(), id: this.detailId}).then((res) => {
								if (res.data&&res.data.error == 0) {
									let downloadUrl =
										this.$ROOT_DIR +
										"/web/CloudLibraryDetail/down?id=" +
										this.detailId +
										"&token="+getToken()
									if (shareId) {
										downloadUrl = downloadUrl +"&share_id="+encodeURIComponent(shareId);
									}
									let link = document.createElement("a");
									link.style.display = "none";
									link.href = downloadUrl;
									document.body.appendChild(link);
									link.click();
								} else if (res.data&&res.data.error == -1) {
									this.$tooltipPop().show(1, res.data.msg)
								} else if (res.data&&res.data.error == -2) {
									this.$tooltipPop().show(2, res.data.msg)
								} else {
									this.$tooltipPop().show(0, res.data.msg)
								}
								// let blob = new Blob([res.data]);
								// let blobUrl = window.URL.createObjectURL(blob);
								// let aLink = document.createElement('a');
								// aLink.style.display = 'none';
								// aLink.href = blobUrl;
								// aLink.setAttribute('download', '') 
								// document.body.appendChild(aLink);
								// aLink.click(); 
								// document.body.removeChild(aLink);
								// window.URL.revokeObjectURL(blobUrl) // 前面创建的url地址最后也要去掉，为了安全和性能
							}).catch((err) => {
								console.log(err);
							});
            }
          });
        }
      });
    },
    //判断是否需要支付购买
    getCanDown(shareId) {
      return new Promise((resolve) => {
        const params = { token: getToken(), pid: this.detailId, share_id: "" };
				if (shareId) {
					params.share_id = decodeURIComponent(shareId)
				}
        getMaterialCanDown(params).then((res) => {
          const canDownStatus = res.data.action;
          resolve(canDownStatus);
        });
      });
    },
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "balance", // 知币余额
			"recommendList"
    ]),
  },
  watch: {
    "payObj.payStatus"(val) {
      // 监听支付弹窗中是否支付成功
      if (val === "paySuccess") {
        this.initData();
      }
    },
    "payObj.isTopUp"(val) {
      // 监听支付弹窗中是否支付成功
      if (val) {
        this.$topUpPop({ data: { balance: this.balance } });
      }
    },
    isLogin: function () {
      // 登录状态发生改变从新加载数据
      this.initData();
    },
		getListParams: {
			handler: function () {
				this.loading = true;
				(this.listStatus.isData = true), (this.listStatus.isNull = false);
				this.$store
					.dispatch("app/getRelatedMaterial", this.getListParams)
					.then((res) => {
						this.loading = false;
						const { data } = res;
						if (data.total == 0) {
							this.$refs.list.clear();
							this.listStatus.isNull = true;
						} else if (data.current_page == data.last_page) {
							this.listStatus.isData = false;
						}
					});
			},
			deep: true,
		},
  },
};
</script>

<style scoped>
.recommendBox {
  margin-top: 0.2rem;
  width: 100%;
  min-width: 1400px;
  padding: 0 1.2rem;
}

.rightBottom {
  margin-top: 0.1rem;
  width: 100%;
  background: #ffffff;
  border-radius: 0.04rem;
  flex: 1;
  overflow: hidden;
}

.rightTop {
  height: 6.91rem;
  width: 100%;
  background: #ffffff;
  border-radius: 0.04rem;
	position: relative;
}

.free {
	position: absolute;
	top: 0;
	right: -0.75rem;
	cursor: pointer;
}
.free img {
	width: 0.55rem;
	/* height: 1.875rem; */
}

.contentLeft {
  flex: 1;
  margin-right: 0.2rem;
  overflow: hidden;
  background: #ffffff;
  padding: 0.3rem;
  min-height: 6.12rem;
}

.contentRight {
  width: 4rem;
  display: flex;
  flex-direction: column;
  height: 6.12rem;
}

.materialDetailContent {
  display: flex;
  
}

.materialDetailBox {
  width: 100%;
  min-width: 1400px;
  background: #f7f6fb;
  padding: 0 2.8rem 0.4rem;
}

.materialDetailHeader {
  padding: 0.2rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.contentLeft img{
  width: 100%;
}
</style>